 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1FIRSTESTRANGEMENT from '@/components/0_chapter1firstestrangement'
 import A_CHAPTER2ATALKINGQIANYUANSWORD from '@/components/1_chapter2atalkingqianyuansword'
 import A_CHAPTER3WASHINGTHEMARROW from '@/components/2_chapter3washingthemarrow'
 import A_CHAPTER4WHOISTHEVISITOR from '@/components/3_chapter4whoisthevisitor'
 import A_CHAPTER5BITTERTRAININGFORTHREEMONTHS from '@/components/4_chapter5bittertrainingforthreemonths'
 import A_CHAPTER6LATENIGHTASSASSINATION from '@/components/5_chapter6latenightassassination'
 import A_CHAPTER7FATHERSINJURY from '@/components/6_chapter7fathersinjury'
 import A_CHAPTER8FIRSTHEARDOFTHEGATEOFHEAVENLYSECRETS from '@/components/7_chapter8firstheardofthegateofheavenlysecrets'
 import A_CHAPTER9MASTER from '@/components/8_chapter9master'
 import A_CHAPTER10THEWAYOFCULTIVATION from '@/components/9_chapter10thewayofcultivation'
 import A0_CHAPTER11ANIMALFIGHTINGRING from '@/components/10_chapter11animalfightingring'
 import A1_CHAPTER12PRIMITIVEORIGINBEAST from '@/components/11_chapter12primitiveoriginbeast'
 import A2_CHAPTER13YEFAMILYMARKET from '@/components/12_chapter13yefamilymarket'
 import A3_CHAPTER14BLACKBROKENSWORD from '@/components/13_chapter14blackbrokensword'
 import A4_CHAPTER15SWORDTEST from '@/components/14_chapter15swordtest'
 import A5_CHAPTER16WANGHAIOFTHEWANGCLAN from '@/components/15_chapter16wanghaiofthewangclan'
 import A6_CHAPTER17BREAKTHROUGHINBATTLE from '@/components/16_chapter17breakthroughinbattle'
 import A7_CHAPTER18KILL from '@/components/17_chapter18kill'
 import A8_CHAPTER19WANGFAMILYCHASE from '@/components/18_chapter19wangfamilychase'
 import A9_CHAPTER20DENSEFORESTBATTLE from '@/components/19_chapter20denseforestbattle'
 import A0_CHAPTER21ENCOUNTEREDBINARYBEAST from '@/components/20_chapter21encounteredbinarybeast'
 import A1_CHAPTER22XUEYANER from '@/components/21_chapter22xueyaner'
 import A2_CHAPTER23PHAGOCYTOSIS from '@/components/22_chapter23phagocytosis'
 import A3_CHAPTER24MASTERYOFTHEELEMENTALISTSNINTHLAYER from '@/components/23_chapter24masteryoftheelementalistsninthlayer'
 import A4_CHAPTER25COUNTERATTACK from '@/components/24_chapter25counterattack'
 import A5_CHAPTER26ZHANWANGJIANG from '@/components/25_chapter26zhanwangjiang'
 import A6_CHAPTER27RETREATINGWITHFULLBODY from '@/components/26_chapter27retreatingwithfullbody'
 import A7_CHAPTER28MASTERTENG from '@/components/27_chapter28masterteng'
 import A8_CHAPTER29REENTERINGTHECOLOSSEUM from '@/components/28_chapter29reenteringthecolosseum'
 import A9_CHAPTER30IRONBACKBLUEWOLF from '@/components/29_chapter30ironbackbluewolf'
 import A0_CHAPTER31WINNINGSTREAK from '@/components/30_chapter31winningstreak'
 import A1_CHAPTER32BLADEMASTER from '@/components/31_chapter32blademaster'
 import A2_CHAPTER33ASENSATIONCAUSEDBYYAMA from '@/components/32_chapter33asensationcausedbyyama'
 import A3_CHAPTER34ARRESTTHEMURDERER from '@/components/33_chapter34arrestthemurderer'
 import A4_CHAPTER35HIGHGAMBLE from '@/components/34_chapter35highgamble'
 import A5_CHAPTER36ASHOWDOWNBETWEENASWORDSMANANDASWORDSMAN from '@/components/35_chapter36ashowdownbetweenaswordsmanandaswordsman'
 import A6_CHAPTER37ACHALLENGEFROMTHEMASTER from '@/components/36_chapter37achallengefromthemaster'
 import A7_CHAPTER38THATRESPLENDENTSWORDLIGHT from '@/components/37_chapter38thatresplendentswordlight'
 import A8_CHAPTER39TEACHERTENGSDISCOVERY from '@/components/38_chapter39teachertengsdiscovery'
 import A9_CHAPTER40YEPINGNANSSHOCK from '@/components/39_chapter40yepingnansshock'
 import A0_CHAPTER41PRELIMINARYCONCOCTING from '@/components/40_chapter41preliminaryconcocting'
 import A1_CHAPTER42CORECONDENSATION from '@/components/41_chapter42corecondensation'
 import A2_CHAPTER43ORIGINBREAKINGMASTERCONGEALINGPEARL from '@/components/42_chapter43originbreakingmastercongealingpearl'
 import A3_CHAPTER44SECONDSEALOFTHEQIANYUANSWORD from '@/components/43_chapter44secondsealoftheqianyuansword'
 import A4_CHAPTER45PARENTHESIS from '@/components/44_chapter45parenthesis'
 import A5_CHAPTER46COOPERATIONWITHTHECOLOSSEUM from '@/components/45_chapter46cooperationwiththecolosseum'
 import A6_CHAPTER47ELDERTONGSEXCLAMATIONS from '@/components/46_chapter47eldertongsexclamations'
 import A7_CHAPTER48LEVELOFINTERESTINTHECOLOSSEUM from '@/components/47_chapter48levelofinterestinthecolosseum'
 import A8_CHAPTER49THEBIGHANDOFTHECOLOSSEUM from '@/components/48_chapter49thebighandofthecolosseum'
 import A9_CHAPTER50READYTOTREATMOTHER from '@/components/49_chapter50readytotreatmother'
 import A0_CHAPTER51MOTHERSAWAKENING from '@/components/50_chapter51mothersawakening'
 import A1_CHAPTER52IYEXIAOAMSOMEONEWHOHASAMOTHERWHOLOVESHIM from '@/components/51_chapter52iyexiaoamsomeonewhohasamotherwholoveshim'
 import A2_CHAPTER53PREPARATIONSBEFORELEAVINGHOME from '@/components/52_chapter53preparationsbeforeleavinghome'
 import A3_CHAPTER54TOTHEGATEOFHEAVENLYSECRETS from '@/components/53_chapter54tothegateofheavenlysecrets'
 import A4_CHAPTER55QINGPINGCITY from '@/components/54_chapter55qingpingcity'
 import A5_CHAPTER56QINGPINGSHAN from '@/components/55_chapter56qingpingshan'
 import A6_CHAPTER57THEPOWERBEHINDTHEROYALFAMILYINTHENIGHTCITY from '@/components/56_chapter57thepowerbehindtheroyalfamilyinthenightcity'
 import A7_CHAPTER58ENCOUNTEREDBYAROBBERY from '@/components/57_chapter58encounteredbyarobbery'
 import A8_CHAPTER59THEPOWEROFTHETENTHOUSANDSWORDSTECHNIQUE from '@/components/58_chapter59thepowerofthetenthousandswordstechnique'
 import A9_CHAPTER60FALLOFFACLIFF from '@/components/59_chapter60falloffacliff'
 import A0_CHAPTER61CAVESKELETON from '@/components/60_chapter61caveskeleton'
 import A1_CHAPTER6210000YEARSPIRITMILK from '@/components/61_chapter6210000yearspiritmilk'
 import A2_CHAPTER63MASTERLEVEL4 from '@/components/62_chapter63masterlevel4'
 import A3_CHAPTER64CISTERNAE from '@/components/63_chapter64cisternae'
 import A4_CHAPTER65CHICKEN from '@/components/64_chapter65chicken'
 import A5_CHAPTER66IGOTCAUGHTUPINIT from '@/components/65_chapter66igotcaughtupinit'
 import A6_CHAPTER67STUPIDBEAN from '@/components/66_chapter67stupidbean'
 import A7_CHAPTER68MOUNTAINOFDESTINYMOUNTAINGATE from '@/components/67_chapter68mountainofdestinymountaingate'
 import A8_CHAPTER69DANYUANPEAKDISCIPLE from '@/components/68_chapter69danyuanpeakdisciple'
 import A9_CHAPTER70IWILLBULLYYOU from '@/components/69_chapter70iwillbullyyou'
 import A0_CHAPTER71FORCEDINTRUSION from '@/components/70_chapter71forcedintrusion'
 import A1_CHAPTER72DANYUANPEAK from '@/components/71_chapter72danyuanpeak'
 import A2_CHAPTER73REVERSINGRIGHTANDWRONG from '@/components/72_chapter73reversingrightandwrong'
 import A3_CHAPTER74IWILLPUNISHYOUWITHTENYEARSOFMENIALWORK from '@/components/73_chapter74iwillpunishyouwithtenyearsofmenialwork'
 import A4_CHAPTER75FLATTENTHEDANYUANPEAK from '@/components/74_chapter75flattenthedanyuanpeak'
 import A5_CHAPTER76GOODBYEMASTER from '@/components/75_chapter76goodbyemaster'
 import A6_CHAPTER77THISISTOOMUCH from '@/components/76_chapter77thisistoomuch'
 import A7_CHAPTER78AN800YEAROLDUNBLOSSOMEDRADIANCEEMITTEDBYTHEHEAVENSSECRETDISC from '@/components/77_chapter78an800yearoldunblossomedradianceemittedbytheheavenssecretdisc'
 import A8_CHAPTER79SECTLEADERAPPEARS from '@/components/78_chapter79sectleaderappears'
 import A9_CHAPTER80GREETINGSGRANDELDER from '@/components/79_chapter80greetingsgrandelder'
 import A0_CHAPTER81GRADEFIVELIFEPILL from '@/components/80_chapter81gradefivelifepill'
 import A1_CHAPTER82RADIXGINSENGSANGUISORBA from '@/components/81_chapter82radixginsengsanguisorba'
 import A2_CHAPTER83ELEMENTALENERGYCOMPATIBILITY from '@/components/82_chapter83elementalenergycompatibility'
 import A3_CHAPTER84WEIRDTESTRESULTS from '@/components/83_chapter84weirdtestresults'
 import A4_CHAPTER85HEAVENDEFYINGCOMPATIBILITY from '@/components/84_chapter85heavendefyingcompatibility'
 import A5_CHAPTER86BREAKTHROUGHLEVEL5 from '@/components/85_chapter86breakthroughlevel5'
 import A6_CHAPTER87MERAKPEAK from '@/components/86_chapter87merakpeak'
 import A7_CHAPTER88ELDESTBROTHER from '@/components/87_chapter88eldestbrother'
 import A8_CHAPTER89DARKSURGE from '@/components/88_chapter89darksurge'
 import A9_CHAPTER90BOOKPAVILION from '@/components/89_chapter90bookpavilion'
 import A0_CHAPTER91THESHADOWEMPERORWASSHOCKED from '@/components/90_chapter91theshadowemperorwasshocked'
 import A1_CHAPTER92THETWOMONARCHSWEREABOUTTOCOLLIDE from '@/components/91_chapter92thetwomonarchswereabouttocollide'
 import A2_CHAPTER93SNATCHANAPPRENTICE from '@/components/92_chapter93snatchanapprentice'
 import A3_CHAPTER94THETWODUMBFOUNDEDMONARCHS from '@/components/93_chapter94thetwodumbfoundedmonarchs'
 import A4_CHAPTER95MERAKPEAKWILLLOSEFACE from '@/components/94_chapter95merakpeakwillloseface'
 import A5_CHAPTER96ONEMOVE from '@/components/95_chapter96onemove'
 import A6_CHAPTER97YOULETSGOTOGETHER from '@/components/96_chapter97youletsgotogether'
 import A7_CHAPTER98SMALLSUCCESSOFTHETHOUSANDSHADOWCONCEPT from '@/components/97_chapter98smallsuccessofthethousandshadowconcept'
 import A8_CHAPTER99HUMANRANKINGGUTIAN from '@/components/98_chapter99humanrankinggutian'
 import A9_CHAPTER100THEPOWEROFTHEONELINEHEAVEN from '@/components/99_chapter100thepoweroftheonelineheaven'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1firstestrangement",
 			"name" : "0_chapter1firstestrangement",
 			"component" : A_CHAPTER1FIRSTESTRANGEMENT
 		},
 		{
 			"path" : "/1_chapter2atalkingqianyuansword",
 			"name" : "1_chapter2atalkingqianyuansword",
 			"component" : A_CHAPTER2ATALKINGQIANYUANSWORD
 		},
 		{
 			"path" : "/2_chapter3washingthemarrow",
 			"name" : "2_chapter3washingthemarrow",
 			"component" : A_CHAPTER3WASHINGTHEMARROW
 		},
 		{
 			"path" : "/3_chapter4whoisthevisitor",
 			"name" : "3_chapter4whoisthevisitor",
 			"component" : A_CHAPTER4WHOISTHEVISITOR
 		},
 		{
 			"path" : "/4_chapter5bittertrainingforthreemonths",
 			"name" : "4_chapter5bittertrainingforthreemonths",
 			"component" : A_CHAPTER5BITTERTRAININGFORTHREEMONTHS
 		},
 		{
 			"path" : "/5_chapter6latenightassassination",
 			"name" : "5_chapter6latenightassassination",
 			"component" : A_CHAPTER6LATENIGHTASSASSINATION
 		},
 		{
 			"path" : "/6_chapter7fathersinjury",
 			"name" : "6_chapter7fathersinjury",
 			"component" : A_CHAPTER7FATHERSINJURY
 		},
 		{
 			"path" : "/7_chapter8firstheardofthegateofheavenlysecrets",
 			"name" : "7_chapter8firstheardofthegateofheavenlysecrets",
 			"component" : A_CHAPTER8FIRSTHEARDOFTHEGATEOFHEAVENLYSECRETS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js